const cmaOps = require('./cmaOperations');

let newArr = null;

module.exports = function (arrayLength, cma_cf_values, cma_bs_values, cma_pl_values) {

  cma_cf_values.cma_cf_1 = cma_pl_values.cma_pl_85;

  cma_cf_values.cma_cf_2 = cma_pl_values.cma_pl_81;

  cma_cf_values.cma_cf_3 = cmaOps.sum(cma_pl_values.cma_pl_22, cma_pl_values.cma_pl_23);

  cma_cf_values.cma_cf_5 = cma_pl_values.cma_pl_51;
  cma_cf_values.cma_cf_6 = cma_pl_values.cma_pl_63;
  cma_cf_values.cma_cf_4 = cmaOps.difference(cma_cf_values.cma_cf_5, cma_cf_values.cma_cf_6);

  // cma_cf_values.cma_cf_8
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = (cma_bs_values.cma_bs_109[i] - cma_bs_values.cma_bs_109[i-1] + cma_bs_values.cma_bs_80[i] - cma_bs_values.cma_bs_80[i-1]) - (cma_bs_values.cma_bs_10[i] - cma_bs_values.cma_bs_10[i-1] - cma_pl_values.cma_pl_82[i]);
  }
  cma_cf_values.cma_cf_8 = newArr;

  cma_cf_values.cma_cf_9 = cmaOps.sum(cma_cf_values.cma_cf_1, cma_cf_values.cma_cf_2, cmaOps.difference(cma_cf_values.cma_cf_3, cma_cf_values.cma_cf_4), cmaOps.difference(cma_cf_values.cma_cf_7, cma_cf_values.cma_cf_8));

  // cma_cf_values.cma_cf_11
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = (cma_bs_values.cma_bs_70[i-1] - cma_bs_values.cma_bs_70[i] - cma_pl_values.cma_pl_66[i] - cma_pl_values.cma_pl_67[i]);
  }
  cma_cf_values.cma_cf_11 = newArr;

  // cma_cf_values.cma_cf_12
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_65[i-1] - cma_bs_values.cma_bs_65[i] + cma_bs_values.cma_bs_69[i-1] - cma_bs_values.cma_bs_69[i] + cma_bs_values.cma_bs_107[i-1] - cma_bs_values.cma_bs_107[i] + cma_pl_values.cma_pl_58[i] + cma_pl_values.cma_pl_60[i] - cma_pl_values.cma_pl_65[i] - cma_pl_values.cma_pl_74[i];
  }
  cma_cf_values.cma_cf_12 = newArr;

  // cma_cf_values.cma_cf_13
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_104[i-1] - cma_bs_values.cma_bs_104[i] + cma_bs_values.cma_bs_87[i-1] - cma_bs_values.cma_bs_87[i] + cma_bs_values.cma_bs_79[i-1] - cma_bs_values.cma_bs_79[i];
  }
  cma_cf_values.cma_cf_13 = newArr;

  // cma_cf_values.cma_cf_14
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_83[i-1] - cma_bs_values.cma_bs_83[i] + cma_bs_values.cma_bs_85[i-1] - cma_bs_values.cma_bs_85[i] + cma_bs_values.cma_bs_88[i-1] - cma_bs_values.cma_bs_88[i] + cma_bs_values.cma_bs_106[i-1] - cma_bs_values.cma_bs_106[i] + cma_bs_values.cma_bs_108[i-1] - cma_bs_values.cma_bs_108[i] + cma_bs_values.cma_bs_111[i-1] - cma_bs_values.cma_bs_111[i];
  }
  cma_cf_values.cma_cf_14 = newArr;

  // cma_cf_values.cma_cf_15
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_8[i] - cma_bs_values.cma_bs_8[i-1] + cma_bs_values.cma_bs_20[i] - cma_bs_values.cma_bs_20[i-1] + cma_bs_values.cma_bs_22[i] - cma_bs_values.cma_bs_22[i-1] + cma_bs_values.cma_bs_51[i] - cma_bs_values.cma_bs_51[i-1] + cma_bs_values.cma_bs_84[i] - cma_bs_values.cma_bs_84[i-1] + cma_pl_values.cma_pl_61[i-1] + cma_pl_values.cma_pl_75[i-1];
  }
  cma_cf_values.cma_cf_15 = newArr;

  // cma_cf_values.cma_cf_16
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_9[i] - cma_bs_values.cma_bs_9[i-1] + cma_bs_values.cma_bs_12[i] - cma_bs_values.cma_bs_12[i-1] + cma_bs_values.cma_bs_21[i] - cma_bs_values.cma_bs_21[i-1] + cma_bs_values.cma_bs_24[i] - cma_bs_values.cma_bs_24[i-1] + cma_bs_values.cma_bs_25[i] - cma_bs_values.cma_bs_25[i-1] + cma_bs_values.cma_bs_26[i] - cma_bs_values.cma_bs_26[i-1] + cma_bs_values.cma_bs_36[i] - cma_bs_values.cma_bs_36[i-1];
  }
  cma_cf_values.cma_cf_16 = newArr;

  cma_cf_values.cma_cf_17 = cmaOps.sum(cma_cf_values.cma_cf_9, cma_cf_values.cma_cf_11, cma_cf_values.cma_cf_12, cma_cf_values.cma_cf_13, cma_cf_values.cma_cf_14, cma_cf_values.cma_cf_15, cma_cf_values.cma_cf_16);

  // cma_cf_values.cma_cf_21
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_102[i] - cma_bs_values.cma_bs_102[i-1];
  }
  cma_cf_values.cma_cf_21 = newArr;

  // cma_cf_values.cma_cf_31
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_23[i] - cma_bs_values.cma_bs_23[i-1];
  }
  cma_cf_values.cma_cf_31 = newArr;

  cma_cf_values.cma_cf_32 = cmaOps.onlyPositiveDifference(cma_cf_values.cma_cf_31, cma_pl_values.cma_pl_46);

  // cma_cf_values.cma_cf_19
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = (cma_bs_values.cma_bs_43[i] - cma_bs_values.cma_bs_43[i-1]) + (cma_bs_values.cma_bs_115[i] - cma_bs_values.cma_bs_115[i-1]) - (cma_bs_values.cma_bs_114[i] - cma_bs_values.cma_bs_114[i-1]) - (cma_bs_values.cma_bs_102[i] - cma_bs_values.cma_bs_102[i-1]) - (cma_bs_values.cma_bs_95[i] - cma_bs_values.cma_bs_95[i-1]) + cma_pl_values.cma_pl_55[i] - cma_pl_values.cma_pl_68[i] - cma_pl_values.cma_pl_76[i] - cma_pl_values.cma_pl_22[i] - cma_pl_values.cma_pl_23[i] + cma_cf_values.cma_cf_21[i] + cma_cf_values.cma_cf_32[i];
  }
  cma_cf_values.cma_cf_19 = newArr;

  // cma_cf_values.cma_cf_20
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_82[i-1] - cma_bs_values.cma_bs_82[i] + cma_pl_values.cma_pl_53[i] + cma_pl_values.cma_pl_54[i];
  }
  cma_cf_values.cma_cf_20 = newArr;

  // cma_cf_values.cma_cf_22
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_97[i-1] - cma_bs_values.cma_bs_97[i] + cma_bs_values.cma_bs_105[i-1] - cma_bs_values.cma_bs_105[i] + cma_bs_values.cma_bs_50[i] - cma_bs_values.cma_bs_50[i-1];
  }
  cma_cf_values.cma_cf_22 = newArr;

  // cma_cf_values.cma_cf_23
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_101[i-1] - cma_bs_values.cma_bs_101[i] + cma_bs_values.cma_bs_100[i-1] - cma_bs_values.cma_bs_100[i] + cma_bs_values.cma_bs_62[i-1] - cma_bs_values.cma_bs_62[i] - cma_pl_values.cma_pl_77[i];
  }
  cma_cf_values.cma_cf_23 = newArr;

  cma_cf_values.cma_cf_24 = cmaOps.difference(cmaOps.sum(cma_pl_values.cma_pl_56, cma_pl_values.cma_pl_56), cma_pl_values.cma_pl_71, cma_pl_values.cma_pl_78);

  cma_cf_values.cma_cf_25 = cmaOps.sum(cma_cf_values.cma_cf_19, cmaOps.difference(cma_cf_values.cma_cf_20, cma_cf_values.cma_cf_21), cma_cf_values.cma_cf_22, cma_cf_values.cma_cf_23, cma_cf_values.cma_cf_24);

  // cma_cf_values.cma_cf_27
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_41[i] - cma_bs_values.cma_bs_41[i-1] + cma_bs_values.cma_bs_44[i] - cma_bs_values.cma_bs_44[i-1] + cma_bs_values.cma_bs_47[i] - cma_bs_values.cma_bs_47[i-1] + cma_bs_values.cma_bs_48[i] - cma_bs_values.cma_bs_48[i-1] + cma_bs_values.cma_bs_49[i] - cma_bs_values.cma_bs_49[i-1] + cma_bs_values.cma_bs_52[i] - cma_bs_values.cma_bs_52[i-1] + cma_bs_values.cma_bs_53[i] - cma_bs_values.cma_bs_53[i-1] + cma_bs_values.cma_bs_55[i] - cma_bs_values.cma_bs_55[i-1];
  }
  cma_cf_values.cma_cf_27 = newArr;

  // cma_cf_values.cma_cf_28
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_38[i] - cma_bs_values.cma_bs_38[i-1] + cma_bs_values.cma_bs_37[i-1] - cma_bs_values.cma_bs_37[i] + cma_bs_values.cma_bs_36[i-1] - cma_bs_values.cma_bs_36[i] + cma_bs_values.cma_bs_13[i] + cma_bs_values.cma_bs_7[i] - cma_bs_values.cma_bs_7[i-1];
  }
  cma_cf_values.cma_cf_28 = newArr;

  // cma_cf_values.cma_cf_29
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_2[i] - cma_bs_values.cma_bs_2[i-1] + cma_bs_values.cma_bs_6[i] - cma_bs_values.cma_bs_6[i-1];
  }
  cma_cf_values.cma_cf_29 = newArr;

  // cma_cf_values.cma_cf_30
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_13[i-1];
  }
  cma_cf_values.cma_cf_30 = newArr;

  // cma_cf_values.cma_cf_33
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_11[i-1] - cma_bs_values.cma_bs_11[i] + cma_pl_values.cma_pl_86[i];
  }
  cma_cf_values.cma_cf_33 = newArr;

  // cma_cf_values.cma_cf_34
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_pl_values.cma_pl_57[i] + cma_pl_values.cma_pl_62[i] - cma_pl_values.cma_pl_70[i] - cma_pl_values.cma_pl_73[i];
  }
  cma_cf_values.cma_cf_34 = newArr;

  cma_cf_values.cma_cf_35 = cmaOps.sum(cma_cf_values.cma_cf_27, cma_cf_values.cma_cf_28, cmaOps.difference(cma_cf_values.cma_cf_29, cma_cf_values.cma_cf_30), cmaOps.difference(cma_cf_values.cma_cf_31, cma_cf_values.cma_cf_32, cma_cf_values.cma_cf_33), cma_cf_values.cma_cf_34);

  cma_cf_values.cma_cf_36 = cmaOps.sum(cma_cf_values.cma_cf_17, cma_cf_values.cma_cf_25, cma_cf_values.cma_cf_35);

  cma_cf_values.cma_cf_38 = cmaOps.sum(cma_cf_values.cma_cf_36, cma_cf_values.cma_cf_37);

  return cma_cf_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_CF.js